import React from 'react';
import '../style/Footer.css';
import logo from '../assets/logo2.png';

const Footer = ({ onNavigate }) => {
  const handleClick = (e, page) => {
    e.preventDefault();
    onNavigate(page);
  };

  return (
    <footer className="footer">
      <div className="footer-top">

        <div className="footer-column">
          <h4>About Us</h4>
          <ul>
            <li>
              <a href="/" onClick={(e) => handleClick(e, 'home')}>
                Who We Are
              </a>
            </li>

            <li>
              <a href="/" onClick={(e) => handleClick(e, 'terms&conditions')}>
                Terms and Conditions
              </a>
            </li>

            <li>
              <a href="/" onClick={(e) => handleClick(e, 'privacy')}>
                Privacy Policy
              </a>
            </li>

            <li>
              <a href="/" onClick={(e) => handleClick(e, 'home')}>
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Services</h4>
          <ul>
            <li><a href="/">Car Loans</a></li>
            <li><a href="/">Insurance</a></li>
            <li><a href="/">Sell Car</a></li>
            <li><a href="/">Used Cars</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Popular Brands</h4>
          <ul>
            <li><a href="https://www.marutisuzuki.com/">Maruti Suzuki</a></li>
            <li><a href="https://www.hyundai.com/">Hyundai</a></li>
            <li><a href="https://www.tata.com/">Tata</a></li>
            <li><a href="https://www.mahindra.com/">Mahindra</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Connect with Us</h4>

          <div className="social-icons">
            <a
              href="https://x.com/CarsChalao"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>

            <a
              href="https://www.instagram.com/cars.chalao/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>

            <a
              href="https://www.linkedin.com/in/carschalao-news/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>

          <div className="footer-logo">
            <img src={logo} alt="CarsChalao Logo" />
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2025 CarsChalao. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;